module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-09.9aee9faf.jpg";